import React, {useEffect, useRef, useState} from 'react'
import {
  createVisits,
  getContentPublicShareLink,
  createTimeSpent,
  downloadFileSignedForContent,
} from '../core/_requests'
import {useLocation} from 'react-router-dom'
import {toast} from 'react-toastify'
import {useIntl} from 'react-intl'
import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/page-navigation/lib/styles/index.css'
import '@react-pdf-viewer/thumbnail/lib/styles/index.css'
import {EmailAccessModal} from '../components/data-room-drawer/EmailAccessModal'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {PasscodeAccessModal} from '../components/data-room-drawer/PasscodeAccessModal'
import axios from 'axios'
import {BasicButton} from '../../widgets/components/UI/BasicButton'
import {ContentViewUI} from '../../widgets/components/ContentViewUI'
import {OtpAccessModal} from '../components/data-room-drawer/OtpAccessModal'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'
import {useAuth} from '../../auth'
import brandingConfig from '../../../../config/brandingConfig'
import {useThemeMode} from '../../../../_metronic/partials'

function ContentPreview() {
  const isDownloadingRef = useRef(false)
  const isListenerAttached = useRef(false)
  const {mode} = useThemeMode()

  const startTimeRef = useRef<number>()
  const visitIdRef = useRef<number>()

  const [showEmailModal, setShowEmailModal] = useState<boolean>(false)

  const {formatMessage} = useIntl()
  const [deviceType, setDeviceType] = useState('')
  const [osType, setOsType] = useState('')
  const [showPasscodeModal, setShowPasscodeModal] = useState<boolean>(false)
  const [fileName, setfileName] = useState('')
  const [emailIdErr, setEmailIdErr] = useState<boolean>(false)
  const [isEnteringEmail, setIsEnteringEmail] = useState<boolean>(false)
  const [isEnteringPasscode, setIsEnteringPasscode] = useState<boolean>(false)
  const [passwordErr, setPasswordErr] = useState<boolean>(false)
  const [email, setEmail] = useState<string>('')
  const [passcode, setPasscode] = useState<string>('')
  const [isDownloadable, setIsDownloadable] = useState<boolean>(false)
  const [contentName, setContentName] = useState<string>('')
  const [showFile, setShowFile] = useState(false)
  const location = useLocation()
  const pathname = location.pathname
  const parts = pathname.split('/')
  const paramValue = parts[parts.length - 1]
  const [city, setCity] = useState('')
  const [country, setCountry] = useState('')
  const [ipAddress, setIpAddress] = useState('')
  const [contentId, setContentId] = useState<string | null>(null)
  const [otp, setOtp] = useState<string>('')
  const [otpErr, setOtpErr] = useState<boolean>(false)
  const [showOtpModal, setShowOtpModal] = useState<boolean>(false)
  const [isEnteringOtp, setIsEnteringOtp] = useState<boolean>(false)
  const {currentUser, companyId} = useAuth()

  const IPSTACK_URL = `${process.env.REACT_APP_IPSTACK_LINK}?access_key=${process.env.REACT_APP_IPSTACK_ACCESS_KEY}&format=1`

  const getDeviceType = () => {
    const ua = navigator.userAgent

    if (
      /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera Mobi|Blazer|Dolfin|Dolphin|Skyfire|Zune/.test(
        ua
      )
    ) {
      return 'MOBILE'
    }
    return 'WEB'
  }

  const getOS = () => {
    const ua = navigator.userAgent
    if (/iPhone|iPad|iPod|Macintosh/.test(ua)) return 'APPLE'
    if (/Win/.test(ua)) return 'WINDOWS'
    if (/android/i.test(ua)) return 'ANDROID'
    return 'Unknown'
  }

  useEffect(() => {
    const os = getOS()
    const deviceTypeView = getDeviceType()
    const find = async () => {
      try {
        const locationApiData = await axios.get(IPSTACK_URL)
        setCity(locationApiData?.data.city)
        setCountry(locationApiData?.data?.country_name)
        setIpAddress(locationApiData?.data?.ip)
      } catch {
        setCity('')
        setCountry('')
        setIpAddress('')
      }
    }
    setDeviceType(deviceTypeView)
    setOsType(os)
    find()
    TagManager.dataLayer({
      dataLayer: {
        event: GTMEvent.ContentPreviewSuccessful,
        action: 'normal',
        metadata: {
          os,
          device_type: deviceType,
          email: email,
          user_id: currentUser?.userId,
          company_id: companyId,
        },
      },
    })
  }, []) // eslint-disable-line

  // useEffect(() => {
  //   if (fileName && city && country) {
  //     createVisitsOfDataRoomFile()
  //   }
  // }, [fileName, country, city]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (fileName) {
      startTimeRef.current = Date.now()
    }
  }, [fileName]) // eslint-disable-line react-hooks/exhaustive-deps

  //handling On Tab close logic
  useEffect(() => {
    const onTabClose = async (event: any) => {
      if (isDownloadingRef.current) {
        return // Don't run the timeSpendData function if downloading
      } else {
        let timeSpent: number | undefined = undefined // Initialize timeSpent

        if (startTimeRef.current !== 0) {
          const endTime = Date.now()
          timeSpent = Math.round((endTime - startTimeRef.current!) / 1000)
        }
        if (timeSpent !== undefined && visitIdRef.current) {
          event.preventDefault()
          // Prevent closing and show a warning message
          event.returnValue = 'Are you sure, you want to leave this page?'
          // Sending data to API

          // Clearing the warning message after the API call is done
          delete event['returnValue']
          await timeSpendData(timeSpent, visitIdRef.current)
        }
      }
    }

    if (!isListenerAttached.current) {
      window.addEventListener('beforeunload', onTabClose)
      isListenerAttached.current = true
    }

    return () => {
      if (isListenerAttached.current) {
        window.removeEventListener('beforeunload', onTabClose)
        isListenerAttached.current = false
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  const Host = window.location.host
  const protocol = window.location.protocol
  const registrationUrl = Host.includes('localhost')
    ? `/auth/registration/?lp=generic&utm_source=recordskeeper.ai&utm_medium=web-app&utm_campaign=file-download-page`
    : `${protocol}//${Host}/auth/registration/?lp=generic&utm_source=recordskeeper.ai&utm_medium=web-app&utm_campaign=file-download-page`

  const getContentPublicByShareLink = async (
    uuid: string,
    passcode: string,
    email: string,
    otp: string | undefined
  ) => {
    try {
      if (email) {
        setIsEnteringEmail(true)
      }
      if (email && passcode) {
        setIsEnteringPasscode(true)
      }
      if (otp) setIsEnteringOtp(true)
      const {
        data: {data, success, errors},
      } = await getContentPublicShareLink(uuid, passcode, email, otp)
      if (success) {
        if (data === 'OTP_SENT') {
          setShowOtpModal(true)
          setShowEmailModal(false)
        } else {
          if (data.otp_verified === 'OTP_VERIFIED' && data.passcode) {
            setShowOtpModal(false)
            setIsEnteringPasscode(false)
            setShowPasscodeModal(true)
          } else {
            setShowOtpModal(false)
            setShowEmailModal(false)
            setIsEnteringOtp(false)
            setContentName(data?.content?.file?.name.split('/').pop())
            setIsDownloadable(data?.allowDownload)
            setfileName(data?.content?.file?.name.split('/').pop())
            setContentId(data?.content?.contentId)
            localStorage.setItem('ContentSessionId', data?.publicSession?.sessionToken)
            if (showPasscodeModal) {
              setShowPasscodeModal(false)
              setIsEnteringPasscode(false)
            }
            if (showEmailModal) {
              setShowEmailModal(false)
              setIsEnteringEmail(false)
            }
            if (showOtpModal) {
              setShowOtpModal(false)
              setIsEnteringOtp(false)
            }
          }
        }
      } else {
        errors.forEach((error: string) => {
          if (error === 'EMAIL_REQUIRED') {
            setShowEmailModal(true)
            setShowOtpModal(false)
          } else if (error === 'INVALID_OTP') {
            toast.error(formatMessage({id: 'Otp is Invalid, Please try again'}))
            setIsEnteringOtp(false)
            setShowOtpModal(true)
            setShowEmailModal(false)
          } else if (error === 'PASSCODE_REQUIRED') {
            setShowEmailModal(false)
            setShowPasscodeModal(true)
            setShowOtpModal(false)
          } else if (error === 'ACL_FAILED') {
            toast.error(formatMessage({id: 'You are not allowed to access the dataroom'}))
            setIsEnteringEmail(false)
            setShowOtpModal(false)
          } else {
            toast.error(formatMessage({id: error}))
            setIsEnteringEmail(false)
            setIsEnteringPasscode(false)
            setShowOtpModal(false)
            setIsEnteringOtp(false)
          }
        })
      }
    } catch (err) {
      console.log(err)
    }
  }
  useEffect(() => {
    getContentPublicByShareLink(paramValue, passcode, email, otp)
  }, []) // eslint-disable-line

  const createVisitsOfDataRoomFile = async () => {
    try {
      if (
        deviceType &&
        osType &&
        city &&
        country &&
        contentId &&
        localStorage.getItem('ContentSessionId')
      ) {
        const {
          data: {data, success, errors},
        } = await createVisits(
          deviceType,
          osType,
          city,
          country,
          ipAddress,
          contentId,
          email,
          localStorage.getItem('ContentSessionId')!
        )
        if (success) {
          visitIdRef.current = data?.visitId
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  const timeSpendData = async (timeSpent: number, visitId: number) => {
    try {
      if (timeSpent && visitId) {
        const {
          data: {success, errors},
        } = await createTimeSpent(timeSpent, visitId)
        if (success) {
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ContentTimeSpendCreatedSuccessful,
              action: 'normal',
              metadata: {
                time_spent: timeSpent,
                visit_id: visitId,
                email: email,
                user_id: currentUser?.userId,
                company_id: companyId,
              },
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ContentTimeSpendCreatedFailed,
              action: 'normal',
              metadata: {
                time_spent: timeSpent,
                visit_id: visitId,
                email: email,
                user_id: currentUser?.userId,
                company_id: companyId,
              },
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  const onDownloadFile = async (contentId: string | null) => {
    isDownloadingRef.current = true
    if (contentId) {
      const {
        data: {data: signedUrl, success},
      } = await downloadFileSignedForContent(contentId, localStorage.getItem('ContentSessionId')!)
      if (success) {
        const a = document.createElement('a')
        a.href = signedUrl
        a.download = 'download'
        document.body.appendChild(a)
        a.click()
        a.remove() // This line is sufficient to remove the element from the DOM
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DownloadSignedFileForContentSuccessful,
            action: 'normal',
            metadata: {
              content_id: contentId,
              email: email,
              user_id: currentUser?.userId,
              company_id: companyId,
            },
          },
        })
      }
      isDownloadingRef.current = false
    }
  }

  return (
    <>
      {fileName && (
        <>
          <div className='vh-100'>
            <div className='px-6 py-4 border-bottom justify-content-between d-flex align-items-center w-100'>
              <div className="w-100">
              <a href={registrationUrl} target='_blank' rel='noreferrer'>
                <img
                  src={mode === 'dark' ? brandingConfig.darkModeLogo : brandingConfig.lightModeLogo}
                  alt='Logo'
                />
              </a>
              </div>
              

              <div className={`w-100 ${isDownloadable ? 'text-center' : 'text-end'}`}>
                <h2 className='font-size-14 lh-base text-dark m-0'>{contentName}</h2>
              </div>

              {isDownloadable && (
                <div className='cursor-pointer w-100 text-end' onClick={() => onDownloadFile(contentId)}>
                  <img
                    src={toAbsoluteUrl('/media/svg/files/download.svg')}
                    alt={formatMessage({id: 'download-icon'})}
                    width={40}
                    height={40}
                  />
                </div>
              )}
            </div>
            <ContentViewUI
              fileName={fileName}
              sessionToken={localStorage.getItem('ContentSessionId')!}
              contentId={contentId}
            />
          </div>
          {!showFile && (
            <div className='blur-container'>
              <BasicButton
                height='44px'
                border='1px solid #4776E6'
                color='#4776E6'
                textColor='white'
                padding='12px 24px'
                onClick={() => {
                  setShowFile(true)
                  createVisitsOfDataRoomFile()
                }}
                buttonText={formatMessage({id: 'Click to view file'})}
                minWidth={56}
              />
            </div>
          )}
        </>
      )}

      <EmailAccessModal
        setAccessModal={setShowEmailModal}
        accessModal={showEmailModal}
        accessLoading={isEnteringEmail}
        AccessId={paramValue}
        onAccess={getContentPublicByShareLink}
        email={email}
        setEmail={setEmail}
        heading={formatMessage({id: 'Enter your email id to access this file'})}
        labelText={formatMessage({id: 'Email Address'})}
        paraText={formatMessage({
          id: 'This Data Room file has been shared with specific email ids, please enter your email id to access this data room.',
        })}
        emailIdErr={emailIdErr}
        setEmailIdErr={setEmailIdErr}
      />
      <PasscodeAccessModal
        setAccessModal={setShowPasscodeModal}
        accessModal={showPasscodeModal}
        onAccess={getContentPublicByShareLink}
        accessLoading={isEnteringPasscode}
        AccessId={paramValue}
        passcode={passcode}
        setPasscode={setPasscode}
        email={email}
        heading={formatMessage({id: 'Enter password to access the file'})}
        labelText={formatMessage({id: 'Enter Passcode'})}
        passwordErr={passwordErr}
        setPasswordErr={setPasswordErr}
      />
      <OtpAccessModal
        setAccessModal={setShowOtpModal}
        accessModal={showOtpModal}
        onAccess={getContentPublicByShareLink}
        accessLoading={isEnteringOtp}
        AccessId={paramValue}
        otp={otp}
        setOtp={setOtp}
        email={email}
        heading={formatMessage({id: 'Enter otp to access Contents'})}
        labelText={formatMessage({id: 'Enter otp'})}
        paraText={formatMessage({
          id: 'Otp has been sent to your email address, Please check the mail',
        })}
        otpErr={otpErr}
        setOtpErr={setOtpErr}
      />
    </>
  )
}

export default ContentPreview
